import React from 'react';
import { Row, Col, Button} from 'antd';
import BlankLayout from '../../layouts/BlankLayout';
import { Link, Redirect, useParams } from 'react-router-dom';
import { BackColorIcon } from '../../elements/CustomIcons/CustomIcons';

const ApprovalOrderSuccess: React.FC = () => {
    const {orderno} = useParams<{orderno: string}>();
    
    if(orderno === undefined || orderno === null || orderno === ':orderno') {
        return (<Redirect
            to={{
                pathname: '/'
            }}
        />)
    }

    return (
        <BlankLayout>
            <div className='content-wrapper marginBottom40px marginTop40px fontSize18px fontBeau' style={{maxWidth: '508px'}}> 
                <Row>
                    <Col span={24}>
                        <h2 className='headerTitle textCenter'>Thank You, Your cart {orderno} has been placed, awaiting approval.</h2>
                        <div>
                            <p>
                                <strong>What happens next?</strong><br/>
                                Your cart is awaiting approval and will be processed once approved.
                            </p>
                            <p>
                                <strong>Still have questions?</strong><br/>
                                See our <Link className='linkUnderline' to='/faqs'>FAQs</Link> page or <Link className='linkUnderline' to='/contact-us'>contact us</Link>.
                            </p>
                        </div>
                        <div className='textCenter marginTop40px'>
                            <Link to='/'><div className='backHome'>
                                <BackColorIcon/>Home
                            </div>
                            </Link>
                        </div>
                    </Col>
                </Row>
            </div>
        </BlankLayout>
    );    
}

export default ApprovalOrderSuccess;
